import axios from "axios";
import { API_ENDPOINTS } from "../Utils/ApiEndPoints";
import axiosInstance from "../Utils/axiosInstance";
class EmployeeProcessService {
  static async setEmployeeData(formData) {
    try {
      
      const url = API_ENDPOINTS.setEmployeeData();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
     
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async setEmployee(formData) {
    try {

      const url = API_ENDPOINTS.setEmployeeValue();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
     
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }
  static async setEmployeePunch(formData) {
    try {
      const url = API_ENDPOINTS.SetEmployeePunch();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (resultndData.statusCode == 200) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {

      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }


  static async setEmpQualification(formData) {
    try {
     
      const url = API_ENDPOINTS.setEmpQualification();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
     
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async setAttendance(formData) {
    try {
      
      const url = API_ENDPOINTS.setAttendance();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
     
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }
  static async setHoliday(formData) {
    try {
     
      const url = API_ENDPOINTS.setHoliday();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }
  static async getEmployeeData(userID) {
    try {

      const url = API_ENDPOINTS.getEmployeeData(userID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getCLMSEmployeeData(userID) {
    try {

      const url = API_ENDPOINTS.getCLMSEmployeeData(userID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getDepartment(EmpCode, PlantID) {
    try {

      const url = API_ENDPOINTS.getDepartment(EmpCode, PlantID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getSubDepartment(DeptID) {
    try {
      // alert(DeptID);
      const url = API_ENDPOINTS.getSubDepartment(DeptID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getDesignation() {
    try {

      const url = API_ENDPOINTS.getDesignation();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getLocation() {
    try {

      const url = API_ENDPOINTS.getLocation();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getQualification() {
    try {

      const url = API_ENDPOINTS.getQualification();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getBank() {
    try {

      const url = API_ENDPOINTS.getBank();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async ExecutProcedure(EmployeeCode, PlantID) {
    try {
      
      const formData = new FormData();

      // EmployeeCode: blank → send empty (API will convert to null)
      if (EmployeeCode && EmployeeCode.trim() !== "") {
        formData.append("EmployeeCode", EmployeeCode.trim());
      } else {
        formData.append("EmployeeCode", "");
      }

      // PlantID: blank → send empty
      if (PlantID !== null && PlantID !== undefined && PlantID !== "") {
        formData.append("PlantID", PlantID);
      } else {
        formData.append("PlantID", "");
      }
      const url = API_ENDPOINTS.getExecuteProcedure();
      const token = localStorage.getItem('token');

      const response = await axiosInstance.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      
      if (result.StatusCode == 200) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getWeekOff() {
    try {

      const url = API_ENDPOINTS.getWeekOff();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getGrades() {
    try {

      const url = API_ENDPOINTS.getGrade();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getPlant(EmpCode) {
    try {

      const url = API_ENDPOINTS.getPlant(EmpCode);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getCompany(mode) {
    try {
     
      const url = API_ENDPOINTS.getCompany(mode);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getShift(PlantID) {
    try {

      const url = API_ENDPOINTS.getShift(PlantID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getVender(mode) {
    try {

      const url = API_ENDPOINTS.getVender(mode);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getEmployeeChart() {
    try {

      const url = API_ENDPOINTS.getEmployeeChart();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getEployeeCode(PlantID) {
    try {

      const url = API_ENDPOINTS.getEmpolyeeCode(PlantID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getEmployeePunch(UserCode, Month) {
    try {
     
      const url = API_ENDPOINTS.getEmployeePunch(UserCode, Month);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (!(result.success && result.data.statusCode === 200)) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }

    } catch (error) {
     
      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async getAttendancePunch(formData) {
    try {
    
      const url = API_ENDPOINTS.getAttendancePunch();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("data not bind:", error);
      return { success: false };
    }
  }


  static async getEmployeeReport(formData) {
    try {

      const url = API_ENDPOINTS.getEmployeeReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
     
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async getEmployeeProfile(formData) {
    try {

      const url = API_ENDPOINTS.getEmployeeProfile(formData);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (!(result.success && result.data.statusCode === 200)) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async getDailyPunch(formData) {
    try {

      const url = API_ENDPOINTS.getDailyPunch();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async getEmployeeSearch(EmpSearch) {
    try {
      const url = API_ENDPOINTS.getEmployeeSearch(EmpSearch);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getEmployeeShift(formData) {
    try {
     
      const url = API_ENDPOINTS.getEmployeeShift();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async setEmployeeShift(formData) {
    try {
      const url = API_ENDPOINTS.setEmployeeShift();
      const token = localStorage.getItem('token');

      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
     
      const result = response.data;
      if (result.statusCode === 200) {
        return { success: true, data: result };
      } else {
        return { success: false, data: result };
      }

    } catch (error) {
      
      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async getEmployeeWeekOff(formData) {
    try {

      const url = API_ENDPOINTS.getEmployeeWeekOff();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async setEmployeeWeekOff(formData) {
    try {
      const url = API_ENDPOINTS.setEmployeeWeekOff();
      const token = localStorage.getItem('token');

      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });

      const result = response.data;
      if (result.result?.length > 0) {
        return { success: true, data: result };
      } else {
        return { success: false, data: result };
      }

    } catch (error) {
      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async saveWeekOffOverride(formData) {
    try {
      const url = API_ENDPOINTS.saveWeekOffOverride();
      const token = localStorage.getItem('token');

      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });

      const result = response.data;
      if (result.result?.length > 0) {
        return { success: true, data: result };
      } else {
        return { success: false, data: result };
      }

    } catch (error) {
      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async getWeekOffOverride(formData) {
    try {

      const url = API_ENDPOINTS.getWeekOffOverride();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getHolidayCalendar(PlantID, Year) {
    try {

      const url = API_ENDPOINTS.getHolidayCalendar(PlantID, Year);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async kentAttendanceSync(fromDate, toDate) {
    try {
      const url = API_ENDPOINTS.kentAttendanceSync(fromDate, toDate);
      const token = localStorage.getItem('token');

      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      const result = response.data;

      if (result.status === 200) {
        return { success: true, data: result };
      } else {
        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occurred:", error);
      return {
        success: false,
        data: error?.response?.data || { message: "Server error" }
      };
    }
  }

  static async getEmployeeSalaryReport(formData) {
    try {
    
      const url = API_ENDPOINTS.getEmployeeSalaryReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
     
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return { success: false };
    }
  }
  static async getEmployeeListReport(formData) {
    try {
     
      const url = API_ENDPOINTS.getEmployeeListReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
     
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return { success: false };
    }
  }
  static async getPayRollGenerator(formData) {
    try {

      const url = API_ENDPOINTS.getPayRollGenerator();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
    
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return { success: false };
    }
  }


  static async setLockPayroll(data) {
    try {
      
      const url = API_ENDPOINTS.setLockPayroll();
      const token = localStorage.getItem('token');
      const formData = new FormData();
      alert(url);
      formData.append("EmployeeCode", data.EmployeeList.join(','));
      formData.append("MonthYear", data.MonthYear);
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
      const result = response.data;
      if (result.statusCode === 200) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async setSelectedLockPayroll(data) {
    try {
     
      const url = API_ENDPOINTS.setLockPayroll();
      const token = localStorage.getItem('token');
      // const formData = new FormData();
      // formData.append("EmployeeCode", data.EmployeeList);
      // formData.append("MonthYear", data.MonthYear);
      const response = await axiosInstance.post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
    
      const result = response.data;
      if (result.result > 0) {

        return { success: true, data: result };
      }
      else {
        return { success: false, data: result };
      }

    } catch (error) {
     
      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async getEmployeeDOLReport(formData) {
    try {
      
      const url = API_ENDPOINTS.getEmployeeDOLReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (response.StatusCode == 200) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return { success: false };
    }
  }

  static async getDailyAttendanceReport(formData) {
    try {
     
      const url = API_ENDPOINTS.getEmployeeDOLReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (response.StatusCode == 200) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return { success: false };
    }
  }

  static async getBlood() {
    try {
     
      const url = API_ENDPOINTS.getBlood();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getEmployeeStatus() {
    try {
     
      const url = API_ENDPOINTS.getEmployeeStatus();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async setEmployeeUpload(formData) {
    try {
      const url = API_ENDPOINTS.setEmployeeUpload();
      const token = localStorage.getItem('token');

      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`,
        },
      });

      const resultData = response.data;

      // ✅ Success case
      if (resultData.statusCode === 200) {
        return { success: true, data: resultData };
      }
      // ⚠️ API returned a handled error (like 400 or custom message)
      else {
        return { success: true, data: resultData };
      }
    } catch (error) {
      console.error("Error uploading employee data:", error);

      // ✅ If backend sent an error message (500, 400 etc.)
      if (error.response && error.response.data && error.response.data.message) {
        return { success: false, data: error.response.data };
      }
      // 🚫 Unknown or network error
      else {
        return { success: false, data: { message: "Server not reachable or unknown error occurred." } };
      }
    }
  }

  static async setPunchUpload(formData) {
    try {
      const url = API_ENDPOINTS.setPunchUpload();
      const token = localStorage.getItem('token');

      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`,
        },
      });

      const resultData = response.data;
      if (resultData.statusCode === 200) {
        return { success: true, data: resultData };
      }
      else {
        return { success: true, data: resultData };
      }
    } catch (error) {
      console.error("Error uploading employee data:", error);
      if (error.response && error.response.data && error.response.data.message) {
        return { success: false, data: error.response.data };
      }
      else {
        return { success: false, data: { message: "Server not reachable or unknown error occurred." } };
      }
    }
  }

  static async setInActiveUpload(formData) {
    try {
      const url = API_ENDPOINTS.setInActiveUpload();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`,
        },
      });

      const resultData = response.data;

      // ✅ Success case
      if (resultData.statusCode === 200) {
        return { success: true, data: resultData };
      }
      // ⚠️ API returned a handled error (like 400 or custom message)
      else {
        return { success: true, data: resultData };
      }
    } catch (error) {
      console.error("Error uploading employee data:", error);

      // ✅ If backend sent an error message (500, 400 etc.)
      if (error.response && error.response.data && error.response.data.message) {
        return { success: false, data: error.response.data };
      }
      // 🚫 Unknown or network error
      else {
        return { success: false, data: { message: "Server not reachable or unknown error occurred." } };
      }
    }
  }
  static async getTemplate(fileName) {
    try {

      const token = localStorage.getItem('token');
      const response = await fetch(API_ENDPOINTS.getTemplate(fileName), {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`
        },
      });

      if (!response.ok) throw new Error("Download failed.");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true; // success
    } catch (error) {
      console.error("Download error:", error);
      alert("File download failed.");
      return false; // failed
    }
  }

  static async getAttendanceChart(PlantID, Mode, ShiftID) {
    try {

      const url = API_ENDPOINTS.getAttendanceChart(PlantID, Mode, ShiftID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }



  static async getGetMastData(Type) {
    try {
      const url = API_ENDPOINTS.getGetMastData(Type);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }


  static async getGetMasterTable() {
    try {
      const url = API_ENDPOINTS.getGetMasterTable();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getAttendancePivotReport(formData) {
    try {

      const url = API_ENDPOINTS.getAttendancePivotReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("data not bind:", error);
      return { success: false };
    }
  }

  static async getMonthlyOTReport(formData) {
    try {

      const url = API_ENDPOINTS.getMonthlyOTReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("data not bind:", error);
      return { success: false };
    }
  }

  static async getPivotInOutReport(formData) {
    try {
      const url = API_ENDPOINTS.getPivotInOutReport();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("data not bind:", error);
      return { success: false };
    }
  }

  static async getAttendanceMonthlyPDF(formData) {
    try {
     
      const url = API_ENDPOINTS.getAttendanceMonthlyPDF();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
        responseType: "blob", // ⬅️ Important for PDF

      });
      return response;
    } catch (error) {
      console.error("Error downloading PDF:", error);
      throw error;
    }
  }

  static async getPlan(PlantID, MonthYear) {
    try {
      const url = API_ENDPOINTS.getPlan(PlantID, MonthYear);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.statusCode === 200) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
  static async getPlanReport(PlantID, MonthYear) {
    try {

      const url = API_ENDPOINTS.getPlanReport(PlantID, MonthYear);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.statusCode === 200) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async setPlan(formData) {
    try {

      const url = API_ENDPOINTS.setPlan();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

      const resultndData = response.data;
      if (resultndData.statusCode === 200) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("data not bind:", error);
      return { success: false };
    }
  }

  static async getShiftMaster(PlantID) {
    try {

      const url = API_ENDPOINTS.getShiftMaster(PlantID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async setShiftMaster(formData) {
    try {
     
      const url = API_ENDPOINTS.setShiftMaster();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (resultndData.statusCode === 200) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("data not bind:", error);
      return { success: false };
    }
  }

  static async getFloorWise(PlantID) {
    try {

      const url = API_ENDPOINTS.getFloorWise(PlantID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async getLineWise(FloorID) {
    try {

      const url = API_ENDPOINTS.getLineWise(FloorID);
      const token = localStorage.getItem('token');
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }
 static async getDepartmentWisePunch(formData) {
    try {

      const url = API_ENDPOINTS.getDepartmentWisePunch();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      });
      
      const resultndData = response.data;
      if (resultndData.result > 0) {

        return { success: true, data: resultndData };
      } else {

        return { success: false, data: resultndData };
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      return { success: false };
    }
  }

  static async getEmployeeFloor(formData) {
    try {
     
      const url = API_ENDPOINTS.getEmployeeFloor();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }

  static async setEmployeeFloor(formData) {
    try {
      const url = API_ENDPOINTS.setEmployeeFloor();
      const token = localStorage.getItem('token');

      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
     
      const result = response.data;
      if (result.statusCode === 200) {
        return { success: true, data: result };
      } else {
        return { success: false, data: result };
      }

    } catch (error) {
      
      if (error.response && error.response.data) {

        const errorMessage = error.response.data.message || "Unknown error from server";
        //alert(errorMessage);
        console.error("API error message:", errorMessage);
        return { success: false, errorMessage };
      } else {
        return { success: false, errorMessage: "Network or unexpected error occurred." };
      }
    }
  }

  static async getEmployeePassword(formData) {
    try {
     
      const url = API_ENDPOINTS.getEmployeePassword();
      const token = localStorage.getItem('token');
      const response = await axiosInstance.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        }
      });
      const result = response.data;
      if (result.result.length > 0) {

        return { success: true, data: result };
      } else {

        return { success: false, data: result };
      }
    }
    catch (error) {
      console.error("Error Occured:", error)
    }
  }


}

export default EmployeeProcessService